import { LocalDate, Period, nativeJs } from '@js-joda/core';
import { Trans, useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

import { useViewerRoles } from '@treams/treams-hooks';
import { useViewerWorkspacePlanQuery } from '@treams/treams-network';
import { Button } from '@treams/treams-ui';

const ExpirationBanner = () => {
	const { data } = useViewerWorkspacePlanQuery();
	const { t } = useTranslation('', { keyPrefix: 'expiration.banner' });
	const { isWorkspaceSuperuser } = useViewerRoles();

	const workspace = data?.viewer.workspace;

	const trial = workspace?.plans.find((plan) => plan.isTrial);

	if (!trial || !trial.endDate) {
		return null;
	}

	const daysRemaining = Period.between(
		LocalDate.now(),
		nativeJs(new Date(trial.endDate)).toLocalDate(),
	).days();

	return (
		<Banner>
			<BannerContent>
				<BannerText>
					<Trans t={t} i18nKey={'text'} values={{ daysLeft: daysRemaining }} />
				</BannerText>

				{isWorkspaceSuperuser && (
					<BannerButtons>
						<Button
							small
							type="whiteTransparant"
							title={<p>{t('buttons.upgrade')}</p>}
							link="/settings/billing"
						/>
						<BannerUpgradeButton
							small
							type="whiteTransparant"
							title={<p>{t('buttons.demo')}</p>}
							target="_blank"
							link="https://treams.com/nl/demo-plannen/"
						/>
					</BannerButtons>
				)}
			</BannerContent>
		</Banner>
	);
};

const Banner = styled.div`
	background-image: ${({ theme }) => theme.images.lineGradient};
`;

const BannerContent = styled.div`
	display: flex;
	flex-direction: row;

	height: 55px;
	width: 100%;

	padding: 10px;
	padding-left: 60px;

	align-items: center;
`;

const BannerText = styled.p`
	color: white;
`;

const BannerButtons = styled.div`
	display: flex;
	flex-direction: row;

	margin-left: auto;
	padding-right: 60px;

	gap: 5px;
`;

const BannerUpgradeButton = styled(Button)`
	${({ theme }) => css`
		background-color: transparent;
		border: 1px solid ${theme.colors.WhiteTransparantMediumSoft};

		&:hover {
			border-color: transparent;
			background-color: ${theme.colors.WhiteTransparantMediumSoft};
		}
	`}
`;

export default ExpirationBanner;
